import { render, staticRenderFns } from "./DashboardAddedPatients.vue?vue&type=template&id=964432d6&scoped=true"
import script from "./DashboardAddedPatients.vue?vue&type=script&lang=js"
export * from "./DashboardAddedPatients.vue?vue&type=script&lang=js"
import style0 from "./DashboardAddedPatients.vue?vue&type=style&index=0&id=964432d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964432d6",
  null
  
)

export default component.exports